module.exports = __webpack_public_path__ + "static/media/north-melbourne-logo.24219ab3.svg";